export default "__VITE_ASSET__BNldvQdH__"